import ProductDetailLayout, { ProductDetailLayoutProps } from '@/features/products/detail/layout';

export type { ProductDetailLayoutProps };

export default ProductDetailLayout;
